const schoolList = {
  743: {
    code: '743',
    name: '원주삼육고등학교',
  },
};

export default schoolList;
